<div class="accordianDiv">
  <h1>Frequently Asked Questions</h1>
  <mat-accordion [togglePosition]="'before'">
    <mat-expansion-panel *ngFor="let d of questions">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{d.title}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        {{d.body}}
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</div>
